<template>
  <div class="downloadContainer">
    <div class="summaryContainer">
      <p class="summaryTitle">Get Yiyo for Desktop</p>
      <p class="summaryContent">Description of product feature in concise manner that wraps to the third line if needed.</p>
      <el-button :plain="true" >Download for Windows</el-button>
      <p class="summaryLink">*MacOS version coming soon...</p>
    </div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.downloadContainer{
    padding: 0;
    margin-top:40px;
    text-align:center;
    padding-bottom:80px;
}

.downloadContainer .summaryContainer{height: 743px;padding-top:238px;}
.downloadContainer .summaryContainer .summaryTitle{
  height: 59px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 59px;
  text-align: center;
  color: #000000;
  
}
.downloadContainer .summaryContainer .summaryContent{
  width: 714px;
  height: 77px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  color: #000000;
  margin:0 auto;
  margin-top:26px;
}
.downloadContainer .summaryContainer .el-button{
  width: 279px;
  height: 63px;
  background: #222222;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 27px;
  color: #FFFFFF;
  margin:0 auto;
  margin-top:41px;
}
.downloadContainer .summaryContainer .el-button:hover{
  opacity:0.9;
  border-color:#000;
  color:#fff;
}

.downloadContainer .summaryContainer .summaryLink{
  margin-top:48px;
}
@media only screen and (max-width: 768px){
  .downloadContainer{
    padding-bottom: 100px !important;
  }
  .downloadContainer .summaryContainer{
    padding-top: 60px !important;
    height: auto;
  }
  .downloadContainer .summaryContainer .summaryContent{
    width: 100%;
    height: auto;
    padding: 0 20px;
  }
  .downloadContainer .summaryContainer .summaryTitle{
    height: auto;
    padding: 0 20px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Download.vue